class Footer {
  constructor() {
    this.init();
  }
  init() {
    const year = new Date().getFullYear();
    document.querySelectorAll(".js-footer-year").forEach(el => {
      el.textContent = year;
    });
  }
}

export default Footer;
